import { stats } from "@/mocks/comics";

export default function StatsSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-foreground-950">
      <div className="max-w-7xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-3">
          平台数据
        </h2>
        <p className="text-foreground-400 text-sm md:text-base mb-10">
          千万用户信赖的韩漫阅读平台，我们用数据说话
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="bg-foreground-900/50 rounded-lg p-6">
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-primary-500/20 flex items-center justify-center">
                <i className={`${stat.icon} text-xl text-primary-400`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-1">
                {stat.value}
              </div>
              <div className="text-xs text-foreground-400">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}